var map = {
	"./bg_attic.png": "X8vS",
	"./bg_autumn.png": "YI2T",
	"./bg_bricks.png": "ob44",
	"./bg_city.png": "gSdQ",
	"./bg_forest.png": "3MI3",
	"./bg_lounge.png": "GDsX",
	"./bg_night.png": "Dt5+",
	"./bg_parksummer.png": "KXTW",
	"./bg_parkwinter.png": "AoS4",
	"./bg_water.png": "akK9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v0uT";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail ^\.\/.*\.png$
// module id = v0uT
// module chunks = 0